import { css } from 'styled-components';

const BORDER_RADIUS = {
  100: '0.125rem',
  200: '0.25rem',
  300: '0.5rem',
  400: '0.75rem',
  500: '1rem',
  600: '1.25rem',
};

export const border = (options = {}) => {
  const variant = options.variant || 'solid';
  const width = `${options.width || 1}px`;
  const color = `var(--${options.color || 'neutral'}-${options.level || 200})`;
  let borderWidth = '';
  switch (options.only) {
    case 'x':
      borderWidth = `0 ${width}`;
      break;
    case 'y':
      borderWidth = `${width} 0`;
      break;
    case 'top':
      borderWidth = `${width} 0 0`;
      break;
    case 'bottom':
      borderWidth = `0 0 ${width}`;
      break;
    case 'left':
      borderWidth = `0 0 0 ${width}`;
      break;
    case 'right':
      borderWidth = `0 ${width} 0 0`;
      break;
    default:
      borderWidth = width;
  }
  return css`
    border: ${variant} ${width} ${color};
    border-width: ${borderWidth};
  `;
};

export const borderRadius = (options = {}) => css`
  border-radius: ${BORDER_RADIUS[options.size || 300]};
`;
